// src/features/product/components/AddProductModal.jsx
import { useEffect, useRef, useState } from 'react';
import { Modal, Button, Form, Spinner, Alert, Row, Col, Container, Tabs, Tab, Card } from 'react-bootstrap';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import ProductDetailTable from './ProductDetailTable';
import { useProductDetails } from '../hooks/useProductDetails';
import Swal from 'sweetalert2';


const ProductModalAddDetailCategories = ({
    show,
    handleClose,
    data,
    addCategoriesDetail }) => {

    const { productDetails, fetchProductDetails } = useProductDetails();

    const [loading, setLoading] = useState(null);
    const [loadingDetail, setLoadingDetail] = useState(null);
    const [detailsReady, setDetailsReady] = useState(false); // Tracks if `details` are ready
    const [error, setError] = useState(null);

    const [productDetailCategories, setProductDetailCategories] = useState({
        name: '',
        categoryProduct: ''
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const cleanedValue = value.replace(/[^a-zA-Z0-9\s\/\\-]/g, '');
        e.target.value = cleanedValue;
        setProductDetailCategories((prevProduct) => ({
            ...prevProduct,
            [name]: cleanedValue,
            categoryProduct: data?.id,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Start loading
        addCategoriesDetail(productDetailCategories);
        setProductDetailCategories({
            name: '',
            categoryProduct: ''
        });
        Swal.fire({
            title: "Success!",
            text: "Created successfully.",
            icon: "success",
            confirmButtonText: "OK",
        });
        handleClose()
    };

    return (
        <Modal
            size="xl"  // 'xl' size for larger modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
            dialogClassName="fullscreen-modal"  // Use dialogClassName for targeting modal styles if needed
            style={{
                maxWidth: '100%',
                height: '100vh', // Fullscreen height
                margin: 0, // Remove margin
                padding: 0, // Remove padding
            }}>
            <Modal.Header closeButton>
                <Modal.Title>Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body className="grid-example">
                {loadingDetail ? (
                    <div className="loading-page">
                        <h3>Loading...</h3>
                        <p>Please wait while we save your data.</p>
                    </div>
                ) : (
                    <Container>
                        <Row>
                            <Card className="mb-2">
                                <Card.Body>
                                    <Form onSubmit={handleSubmit}>
                                        <Container>
                                            <Row>
                                                <Form.Group className="mb-2">
                                                    <Form.Label>Detail Category Product</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        value={productDetailCategories.name}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Button variant="primary" type="submit">
                                                Add Detail Category Product
                                            </Button>
                                        </Container>
                                    </Form>
                                </Card.Body>
                            </Card>
                            <Container>
                                <Row>

                                </Row>
                            </Container>
                        </Row>
                    </Container>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ProductModalAddDetailCategories;
